import { render, staticRenderFns } from "./OrganicFertilizerApplication.vue?vue&type=template&id=618a8d5a&scoped=true"
import script from "./OrganicFertilizerApplication.vue?vue&type=script&lang=js"
export * from "./OrganicFertilizerApplication.vue?vue&type=script&lang=js"
import style0 from "./OrganicFertilizerApplication.vue?vue&type=style&index=0&id=618a8d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a8d5a",
  null
  
)

export default component.exports